import MaskedInput from './MaskedInput';

export default MaskedInput;
